

<template>
  <div class="container has-text-centered">
    <section class="hero is-fullheight">
      <div class="hero-body has-text-centered">
        <div class="login">
          <img
            style="padding: 10px"
            src="../assets/migholding.jpeg"
            width="325px"
          />
          <h2 class="forgot-password">Reset Password</h2>
          <p>Enter your new password below.</p>
          <div style="margin-top: 30px"></div>

          <form>
            <div class="field">
              <div class="control">
                <p>Password</p>
                <input
                  class="input is-medium is-rounded"
                  type="password"
                  v-model="form.password"
                  @blur="$v.form.password.$touch()"
                  placeholder="********"
                  autocomplete="password"
                />

                <div class="error" v-if="!$v.form.password.minLength">
                  Password must have at least 8 letters.
                </div>

                <div v-if="$v.form.password.$error" class="form-error">
                  <span v-if="!$v.form.password.required" class="help is-danger"
                    >Password is Required.</span
                  >
                  <!-- <span
                    v-if="!$v.form.email.email"
                    class="help is-danger"
                  >Email Address is not Valid</span>-->
                </div>
              </div>
            </div>

            <div class="field">
              <div class="control">
                <p>Confirm Password</p>
                <input
                  class="input is-medium is-rounded"
                  type="password"
                  v-model="form.passwordConfirm"
                  @blur="$v.form.passwordConfirm.$touch()"
                  placeholder="********"
                  autocomplete="password"
                />

                <div v-if="$v.form.passwordConfirm.$error" class="form-error">
                  <span
                    v-if="!$v.form.passwordConfirm.required"
                    class="help is-danger"
                    >Password Confirmation is Required.</span
                  >

                  <div
                    class="error"
                    v-if="!$v.form.passwordConfirm.sameAsPassword"
                  >
                    Passwords must be identical.
                  </div>
                  <!-- <span
                    v-if="!$v.form.email.email"
                    class="help is-danger"
                  >Email Address is not Valid</span>-->
                </div>
              </div>
            </div>

            <button
              class="button is-block is-fullwidth is-primary is-medium is-rounded"
              @click.prevent="resetPasswordSubmitted"
              :disabled="isFormInvalid"
            >
              <b-icon
                pack="fas"
                icon="sync-alt"
                :custom-size="[{ 'fa-lg': isLoading }]"
                :custom-class="[{ 'fa-spin': isLoading }]"
              ></b-icon>
              <span style="margin-left: 15px">SAVE</span>
            </button>
          </form>
          <br />
          <nav class="level">
            <div class="level-item has-text-centered">
              <div>
                <router-link to="/login">
                  <a>Have access to your account? Back to Login</a>
                </router-link>
              </div>
            </div>
            <!-- <div class="level-item has-text-centered">
              <div>
                <a href="#">Create an Account</a>
              </div>
            </div>-->
          </nav>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
export default {
  data() {
    return {
      form: {
        password: '',
        passwordConfirm: '',
      },
      isLoading: false,
    };
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
      },
      passwordConfirm: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
  computed: {
    resetToken() {
      return this.$route.query.resetToken;
    },
    isFormInvalid() {
      return this.$v.form.$invalid;
    },
  },

  methods: {
    resetPasswordSubmitted() {
      this.isLoading = true;
      this.$v.form.$touch();
      // debugger;
      let myResetToken = this.resetToken;
      //   submitResetPassword
      this.$store
        .dispatch('auth/submitResetPassword', {
          formData: this.form,
          resetToken: this.resetToken,
        })
        .then(() => {
          this.isLoading = false;
          this.$buefy.snackbar.open({
            message: `Password was Reset Successfully. Now you can login into the system with new password.`,
            queue: false,
          });
        })
        .catch((errMessage) => {
          // console.log(errMessage);
          this.$buefy.snackbar.open({
            message: `Failed to Reset Password ${errMessage}`,
            queue: false,
          });
          this.isLoading = false;
        });
    },
  },
};
</script>

<style  scoped>
.forgot-password {
  font-size: xx-large;
}

.hero.is-success {
  background: #f2f6fa;
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.box {
  margin-top: 5rem;
}
.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}
.avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

@media screen and (min-width: 1024px) {
  .container {
    padding-right: 12rem;
  }
}

.hero.is-success {
  background: #f2f6fa;
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
/* .box {
  margin-top: 5rem;
} */
/* .avatar {
  margin-top: -70px;
  padding-bottom: 20px;
} */
/* .avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
} */
/* input {
  font-weight: 300;
} */
/* p {
  font-weight: 700;
} */
/* p.subtitle {
  padding-top: 1rem;
} */

/* .login-hr {
  border-bottom: 1px solid black;
} */

/* .has-text-black {
  color: black;
} */

/* .field {
  padding-bottom: 10px;
} */
/* 
.fa {
  margin-left: 5px;
} */
/* 
* {
  font-family: 'Nunito Sans', sans-serif;
} */

.hero-body {
  justify-content: center;
}
.login {
  border-radius: 25px;
  padding: 1.5rem;
  box-shadow: 2px 2px 2px #0372bb, -2px -2px 4px #0372bb;
}

.background {
  background-color: #1d1e21;
}

a {
  font-weight: 600;
}

.button.is-primary {
  background-color: #0372bb;
  border-color: transparent;
  color: #fff;
}
</style>